import { render } from "./BarChartC.vue?vue&type=template&id=1ca477de&scoped=true"
import script from "./BarChartC.vue?vue&type=script&lang=ts"
export * from "./BarChartC.vue?vue&type=script&lang=ts"

import "./BarChartC.vue?vue&type=style&index=0&id=1ca477de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ca477de"

export default script